"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var Modal_1 = __importDefault(require("@material-ui/core/Modal"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var Box_1 = require("./Box");
var ClearButton_1 = require("./ClearButton");
var Paper_1 = require("./Paper");
var Typography_1 = require("./Typography");
var useModalStyles = (0, system_1.makeStyles)(function (theme) { return ({
    paper: {
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: theme.go.schemes.spacing.units.L,
        outline: 'none',
        position: 'relative',
        flexDirection: 'column',
    },
    scrollablePaper: {
        display: 'inline-flex',
        verticalAlign: 'middle',
        textAlign: 'left',
        margin: theme.go.schemes.spacing.units.L,
    },
    flexPaper: {
        maxHeight: "calc(100% - ".concat(2 * theme.go.schemes.spacing.units.L, "px)"),
        display: 'flex',
        overflowY: 'auto',
    },
    backdrop: {
        backgroundColor: "".concat((0, utils_1.changeAlpha)(theme.go.schemes.colors.system.BgInvert, 0.4), " !important"),
    },
    closeIcon: {
        marginLeft: theme.go.schemes.spacing.units.M,
        // поднимаем иконку если на нее наезжает контент
        // (например кто-то сделал отрицательный марджин)
        transform: 'translateZ(1px)',
    },
    absoluteCloseIcon: {
        position: 'absolute',
        top: theme.go.schemes.spacing.units.L,
        right: theme.go.schemes.spacing.units.L,
    },
    scrollContainer: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        overflow: 'auto',
        boxSizing: 'border-box',
        outline: 'none',
        '&::after': {
            width: 0,
            height: '100%',
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
        },
    },
    flexContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        outline: 'none',
    },
}); });
var useModalComponentsStyles = (0, system_1.makeStyles)({
    title: {
        flex: '0 0 auto',
    },
    body: {
        overflowY: 'auto',
        boxSizing: 'content-box',
        flex: '1 1 auto',
    },
    footer: {
        display: 'flex',
        flex: '0 0 auto',
    },
});
function ModalTitle(_a) {
    var children = _a.children, className = _a.className, params = __rest(_a, ["children", "className"]);
    var title = useModalComponentsStyles().title;
    return (react_1.default.createElement(Typography_1.Typography, __assign({ component: "div", variant: "title" }, params, { className: (0, utils_1.cn)(title, className) }), children));
}
function ModalBody(_a) {
    var children = _a.children, className = _a.className, params = __rest(_a, ["children", "className"]);
    var body = useModalComponentsStyles().body;
    return (react_1.default.createElement(Box_1.Box, __assign({ className: (0, utils_1.cn)(className, body), mt: "XL" }, params), children));
}
function ModalFooter(_a) {
    var children = _a.children, params = __rest(_a, ["children"]);
    var footer = useModalComponentsStyles().footer;
    return (react_1.default.createElement(Box_1.Box, __assign({ className: footer, mt: "40px" }, params), children));
}
exports.Modal = Object.assign(function Modal(_a) {
    var children = _a.children, open = _a.open, _b = _a.title, title = _b === void 0 ? '' : _b, onClose = _a.onClose, classes = _a.classes, scrollable = _a.scrollable, onBackdropClick = _a.onBackdropClick, disableBackdropClick = _a.disableBackdropClick, rest = __rest(_a, ["children", "open", "title", "onClose", "classes", "scrollable", "onBackdropClick", "disableBackdropClick"]);
    var _c = useModalStyles(), scrollablePaper = _c.scrollablePaper, paper = _c.paper, flexPaper = _c.flexPaper, backdrop = _c.backdrop, closeIcon = _c.closeIcon, absoluteCloseIcon = _c.absoluteCloseIcon, scrollContainer = _c.scrollContainer, flexContainer = _c.flexContainer;
    var mouseDownTarget = react_1.default.useRef();
    var handleMouseDown = function (event) {
        mouseDownTarget.current = event.target;
    };
    var handleBackdropClick = function (event) {
        // Ignore the events not coming from the "backdrop"
        // We don't want to close the dialog when clicking the dialog content.
        if (event.target !== event.currentTarget) {
            return;
        }
        // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownTarget.current) {
            return;
        }
        mouseDownTarget.current = null;
        if (onBackdropClick) {
            onBackdropClick(event);
        }
        if (!disableBackdropClick && onClose) {
            onClose();
        }
    };
    var paperEl = (react_1.default.createElement(Paper_1.Paper, { className: (0, utils_1.cn)(paper, classes === null || classes === void 0 ? void 0 : classes.paper, scrollable ? scrollablePaper : flexPaper) },
        react_1.default.createElement(Box_1.Box, { justifyContent: "space-between", flex: "0 0 auto" },
            !!title && react_1.default.createElement(ModalTitle, { className: classes === null || classes === void 0 ? void 0 : classes.title }, title),
            !!onClose && (react_1.default.createElement(ClearButton_1.ClearButton, { className: (0, utils_1.cn)(title ? closeIcon : absoluteCloseIcon, classes === null || classes === void 0 ? void 0 : classes.closeIcon), onClick: onClose }))),
        children));
    return (react_1.default.createElement(Modal_1.default, __assign({ open: open, BackdropProps: {
            className: (0, utils_1.cn)(backdrop, classes === null || classes === void 0 ? void 0 : classes.backdrop),
        }, onClose: onClose, disableBackdropClick: disableBackdropClick, onBackdropClick: onBackdropClick }, rest),
        react_1.default.createElement("div", { onMouseDown: handleMouseDown, onMouseUp: handleBackdropClick, className: scrollable ? scrollContainer : flexContainer }, paperEl)));
}, {
    Body: ModalBody,
    Footer: ModalFooter,
    Title: ModalTitle,
});
